<fmnts-modal-title>{{ title() }}</fmnts-modal-title>
<fmnts-modal-content>{{ content() }}</fmnts-modal-content>
<fmnts-modal-actions>
  <button
    type="button"
    fmnts-button
    variant="filled"
    action="primary"
    (click)="onClose.emit('ok')"
  >
    {{ 'ok' | translate }}
  </button>
</fmnts-modal-actions>
